import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    mode: localStorage.getItem('mode') || 'dark',
    eye: localStorage.getItem('eye') || 'open' 
}

export const modeSlice = createSlice({
    name: 'mode',
    initialState,
    reducers: {
        switchMode: (state, action) => {
            state.mode = action.payload;  
            localStorage.setItem('mode', state.mode);
          
        },
        switchEye: (state, action) => {
            state.eye = action.payload;  
            localStorage.setItem('eye', state.eye);
          
        }        
    }
})

export const {switchMode, switchEye} = modeSlice.actions;
export default modeSlice.reducer;